<template>
  <main class="px-10 py-20 text-center">
    <slot />
    <div class="mx-auto mt-5 text-center text-sm opacity-25">
      [Home Layout]
    </div>
  </main>
</template>
